import * as React from "react";
const SvgInstallMobile = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 18H7V6h7V1H5v22h14v-7h-2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18 14 5-5-1.41-1.41L19 10.17V3h-2v7.17l-2.59-2.58L13 9z",
  fill: "currentColor"
}));
export default SvgInstallMobile;